import { Alert, Col, Container, ListGroup, Row, Spinner } from "react-bootstrap";
import Status from "../../enums/Status";
import IDSAR from "../../models/dsar/IDSAR";
import sarService from "../../services/sarService";
import { v4 as uuid } from 'uuid';
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import Request from './Request';

const SARsHeader = () => {
    const { t } = useTranslation();

    return (
        <ListGroup.Item key={uuid()}>
            <Container fluid className="d-none d-lg-block">
                <Row>
                    <Col xs={3} className="fw-bold">{t("dsar.my.table.headers.id")}</Col>
                    <Col xs={2} className="fw-bold">{t("dsar.my.table.headers.custodian")}</Col>
                    <Col xs={2} className="fw-bold">{t("dsar.my.table.headers.type")}</Col>
                    <Col xs={3} className="fw-bold">{t("dsar.my.table.headers.status")}</Col>
                    <Col xs={2} className="fw-bold">{t("dsar.my.table.headers.created")}</Col>
                </Row>
            </Container>
        </ListGroup.Item>
    );
}

export default function Requests() {
    const { t } = useTranslation();

    const [requests, setRequests] = useState<IDSAR[]>([]);
    const [status, setStatus] = useState<Status>(Status.LOADING);

    useEffect(() => {
        getRequests(setRequests)
            .then(() => setStatus(Status.LOAD_SUCCESS))
            .catch(() => setStatus(Status.LOAD_ERROR));
    }, []);

    return (
        <Container fluid>
            <Row>
                <Col>
                    <h2>{t("dsar.my.title")}</h2>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    {
                        (
                            status === Status.LOADING &&
                            <div className="text-center">
                                <Spinner />
                                <span className="d-block sfw-bold">{t("dsar.my.loading")}</span>
                            </div>
                        ) ||
                        (
                            status === Status.LOAD_ERROR &&
                            <Alert variant="danger">
                                {t("dsar.my.errors.general")}
                            </Alert>
                        ) ||
                        (
                            requests.length === 0 &&
                            <Alert variant="info">
                                {t("dsar.my.errors.noRequests")}
                            </Alert>
                        ) ||
                        <ListGroup variant="flush">
                            <SARsHeader />
                            {
                                requests.map(request => <Request key={uuid()} dsar={request} />)
                            }
                        </ListGroup>
                    }
                </Col>
            </Row>
        </Container>
    );
}

async function getRequests(setRequests: (requests: IDSAR[]) => void) {
    const sars = await sarService.getSARs();
    setRequests(sars);
}